import { render } from "./BravoPay.vue?vue&type=template&id=66e68bd2&scoped=true"
import script from "./BravoPay.vue?vue&type=script&lang=js"
export * from "./BravoPay.vue?vue&type=script&lang=js"

import "./BravoPay.vue?vue&type=style&index=0&id=66e68bd2&scoped=true&lang=css"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-66e68bd2"]])

export default __exports__